import axios from 'axios';
import { withBase } from './url';

let csrfToken: string | null = null;
let refreshPromise: Promise<string> | null = null;
let consecutiveFailures = 0;
const MAX_CONSECUTIVE_FAILURES = 5;

export function getCsrfToken(): string | null {
  return csrfToken;
}

async function fetchCSRFToken(): Promise<string> {
  try {
    // baseURL: '' - axios.create() merges in axios.defaults, and queries.js mutates
    // that global default's baseURL to '/api'; pin it here so it can't be inherited
    // and double up with the '/api' already in the path below.
    const cleanAxios = axios.create({
      baseURL: '',
      withCredentials: true,
      timeout: 10000
    });
    const response = await cleanAxios.get<{ csrfToken: string }>(
      withBase('/api/csrf-token')
    );
    return response.data.csrfToken;
  } catch (error) {
    consecutiveFailures++;
    throw error;
  }
}

export async function refreshCSRFToken(): Promise<void> {
  if (consecutiveFailures >= MAX_CONSECUTIVE_FAILURES) {
    throw new Error('Too many CSRF refresh failures. Please refresh the page.');
  }

  if (refreshPromise) {
    try {
      await refreshPromise;
      return;
    } catch {
      // existing promise failed - fall through and try again
    }
  }

  refreshPromise = fetchCSRFToken();

  try {
    csrfToken = await refreshPromise;
    consecutiveFailures = 0;
  } finally {
    refreshPromise = null;
  }
}
